const attributeSteps = () => {
  const $nextButton = $('.next-prod-option-btn');
  const $customerNotes = $('.customer-notes');

  // if width and height have default values on load then enable the next button
  if ($('.size-options').length && $('#pa_height').val() != '' && $('#pa_width').val() != '') {
    enableButton();
  }

  // if size option has default values on load then enable the next button
  if ($('#pa_size').length && $('#pa_size').val() != '') {
    enableButton();
  }

  // width and height change event
  $(document).on('change', '.product-option-wrap.size-options.active-option select', function () {
    const $widthSelect = $('#pa_width');
    const $heightSelect = $('#pa_height');

    if ($widthSelect.val() && $heightSelect.val()) {
      enableButton();
    } else {
      disableButton();
    }
  });

  // change event for all attributes except the width and height selects
  $(document).on('change', '.product-option-wrap.active-option:not(.size-options) select', function () {
    if ($(this).val()) {
      enableButton();
    } else {
      disableButton();
    }
  });

  // next button click event
  $nextButton.on('click', function () {
    let nextSection = $('.product-option-wrap.active-option').next('.product-option-wrap');
    let nextNextSection = nextSection.next('.product-option-wrap');

    $('.product-option-wrap').removeClass('active-option');

    nextSection
      .addClass('active-option')
      .show();

    // if the new active section has a default value then enable the button
    if (nextSection.find('select').val() != '') {
      enableButton();
    } else {
      disableButton();
    }

    // if section after next exists then set the button value otherwise hide the button
    if (nextNextSection.length) {
      let nextOptionName = nextNextSection.data('option-name');

      updateButton(nextOptionName);
    } else {
      hideButton();
      showExtraOptions();
    }
  });

  function updateButton(optionName) {
    $nextButton.text('NEXT: ' + optionName);
  }

  function hideButton() {
    $nextButton.hide();
  }

  function enableButton() {
    $nextButton.prop('disabled', false);
  }

  function disableButton() {
    $nextButton.prop('disabled', true);
  }

  function showExtraOptions() {
    $('.single_variation_wrap .extra-options').show();
    $customerNotes.show();
  }

  const valueCell = document.querySelector('.thwepo_number.width .value.leftside');

  if (valueCell) {
    // Modify the text content inside the <td> by removing the parentheses and the content inside them
    valueCell.innerHTML = valueCell.innerHTML.replace(/\(\s*<span.*<\/span>\s*\)/, '').trim();
  }

}








export default attributeSteps;



// WEBPACK FOOTER //
// ./scripts/components/attribute-steps.js